module.exports = __webpack_public_path__ + "images/emoji/x.20be58b2114b9bc0dba0.png";